import { css, keyframes, SerializedStyles } from '@emotion/react';
import { getSizeValue } from '../../theming';
import { SkeletonVariant } from './Skeleton.types';

const waveKeyframe = keyframes`
    0% {
        transform: translateX(-100%);
    }

    50% {
        /* +0.5s of delay between each loop */
        transform: translateX(100%);
    }

    100% {
        transform: translateX(100%);
    }
`;

export const STATIC_STYLES: SerializedStyles = css`
    border-radius: var(--skeleton-radius);
    background-color: rgba(0, 0, 0, 0.1);

    position: relative;
    overflow: hidden;

    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        animation: ${waveKeyframe} 2s linear 0.5s infinite;
        background: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.06), transparent);
    }

    &[data-variant='text'] {
        height: auto;
        border-radius: 4px;
        color: transparent;
        &:empty::before {
            content: '\\00a0';
        }
    }

    &[data-with-children] {
        height: auto;
        max-width: var(--skeleton-max-width);
        > * {
            visibility: hidden;
        }
    }
`;

export function useDynamicStyles(
    variant: SkeletonVariant,
    radius?: number | string,
    hasWidth = false
): React.CSSProperties {
    return {
        '--skeleton-radius': variant === 'circle' ? '50%' : radius ? getSizeValue(radius) : undefined,
        '--skeleton-max-width': !hasWidth ? 'fit-content' : undefined,
    } as React.CSSProperties;
}
